/**
 * Cross-tab signal for "the OAuth tab came back".
 *
 * The platforms' consent pages send Cross-Origin-Opener-Policy, which severs the
 * opener↔tab relationship: reading `popup.closed` / `popup.location` then logs a
 * COOP warning on every poll and returns nothing usable. A BroadcastChannel
 * between same-origin tabs sidesteps the opener entirely.
 */

const CHANNEL_NAME = 'promote-oauth-return';

/** Marker we add to the OAuth redirect URL so the returning tab can identify itself. */
export const OAUTH_RETURN_PARAM = 'promoteOauthReturn';

export interface OAuthReturnMessage {
  platform: string;
}

export function publishOAuthReturn(platform: string): void {
  if (typeof BroadcastChannel === 'undefined') return;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage({ platform } satisfies OAuthReturnMessage);
  channel.close();
}

/** Returns an unsubscribe function. */
export function subscribeOAuthReturn(onReturn: (message: OAuthReturnMessage) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => undefined;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (event: MessageEvent<OAuthReturnMessage>) => onReturn(event.data);
  return () => channel.close();
}
